import React from 'react';
import { IComponentText } from '../../component';
import { getRuntimeLocale, resolveLocaleText } from '../../utils/localeText';

import './text.scss';

const AllForText = function(props: IComponentText) {
  const { richtext, richtext_i18n } = props;
  const currentRichtext = resolveLocaleText(
    richtext,
    richtext_i18n,
    getRuntimeLocale()
  );
  return (
    <div className="all-for-text">
      <div
        className="html-rawdata"
        dangerouslySetInnerHTML={{ __html: currentRichtext || '' }}
      ></div>
    </div>
  );
};

export default AllForText;
